export default __webpack_public_path__ + "static/media/wind.d35fef2c.svg";